(function (Translator) {
    // es
    Translator.add("address", "Direcci\u00f3n:", "PayseraMapBundle", "es");
    Translator.add("friday", "Viernes", "PayseraMapBundle", "es");
    Translator.add("monday", "Lunes", "PayseraMapBundle", "es");
    Translator.add("no_results", "No hay resultados encontrados", "PayseraMapBundle", "es");
    Translator.add("saturday", "S\u00e1bado", "PayseraMapBundle", "es");
    Translator.add("search_placeholder", "Introduzca el fragmento", "PayseraMapBundle", "es");
    Translator.add("service.cash_in", "Dep\u00f3sito en efectivo", "PayseraMapBundle", "es");
    Translator.add("service.cash_out", "Disposici\u00f3n de efectivo", "PayseraMapBundle", "es");
    Translator.add("service.identification", "Desempe\u00f1o de la identificaci\u00f3n", "PayseraMapBundle", "es");
    Translator.add("service.pay", "Contribuciones", "PayseraMapBundle", "es");
    Translator.add("services", "Servicios:", "PayseraMapBundle", "es");
    Translator.add("sunday", "Domingo", "PayseraMapBundle", "es");
    Translator.add("thursday", "Jueves", "PayseraMapBundle", "es");
    Translator.add("tuesday", "Martes", "PayseraMapBundle", "es");
    Translator.add("wednesday", "Mi\u00e9rcoles", "PayseraMapBundle", "es");
    Translator.add("working_hours", "Horas laborales:", "PayseraMapBundle", "es");
})(Translator);
